/*
 * Scroll Direction
 *
 **/
import { debounce } from 'lodash';

custom.scrollDirection = (() => {
  // variables
  const scrollDownClass = 'js-scroll-direction-down';
  const scrollUpClass = 'js-scroll-direction-up';
  const scrollTopClass = 'js-scroll-window-top';
  var lastScrollTop = 0;

  function scrollHandler() {
    var $navigation = $('.navigation');
    var shadowClass = 'has-shadow';
    if ($(window).scrollTop() <= $navigation.height()) {
      $navigation.removeClass(shadowClass);
    } else {
      $navigation.addClass(shadowClass);
    }

    var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
    if (st === 0) {
      // page top code
      document.body.classList.remove(scrollUpClass);
      document.body.classList.remove(scrollDownClass);
      document.body.classList.add(scrollTopClass);
    } else if (st > lastScrollTop) {
      // downscroll code
      document.body.classList.remove(scrollUpClass);
      document.body.classList.remove(scrollTopClass);
      document.body.classList.add(scrollDownClass);
    } else {
      // upscroll code
      document.body.classList.remove(scrollDownClass);
      document.body.classList.remove(scrollTopClass);
      document.body.classList.add(scrollUpClass);
    }
    lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
  }

  function init() {
    window.addEventListener('scroll', debounce(scrollHandler, 50), false);
  }

  return {
    init,
  };
})();
custom.scrollDirection.init();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/scroll-direction.js